module.exports = __webpack_public_path__ + "page_static/img/logo_black.e548a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black.png
// module id = q3zs
// module chunks = 13